import React from 'react';
import {Flex, Tabs} from "antd";
import CoursesList from "./List/CoursesList";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import MyText from "../../../../components/UI/Text/MyText";
import CreateCategory from "./CreateCategory/CreateCategory";
import CreateCourse from "./CreateCourse/CreateCourse";
import ImportSubjectsListeners from "./ImportSubjects/ImportSubjectsListeners";

const CoursesPage = () => {

    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'list'}/>,
            children: <CoursesList/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'createCategory'}/>,
            children: <CreateCategory/>,
        },
        {
            key: '3',
            label: <IntlMessage id={'createCourse'}/>,
            children: <CreateCourse/>,
        },
        {
            key: '4',
            label: "Для слушателей (предметы)",
            children: <ImportSubjectsListeners/>,
        },
    ]

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={'courses'}/></MyText>
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems}/>
        </Flex>
    );
};

export default CoursesPage;